module.exports = __webpack_public_path__ + "static/arataki-itto-banner-4182cabcfcd29d62b6a2d188ec57298d.png";